import { RouteRecordRaw } from "vue-router";
import Dashboard from "@/modules/Parkom/Pages/Dashboard.vue";
import ParkingSpacesIndex from "@/modules/Parkom/Submodules/ParkingSpaces/Pages/Index.vue";
import ParkingSpotsIndex from "@/modules/Parkom/Submodules/ParkingSpots/Pages/Index.vue";
import SensorsIndex from "@/modules/Parkom/Submodules/Sensors/Pages/Index.vue";
import DisplaysIndex from "@/modules/Parkom/Submodules/Displays/Pages/Index.vue";
import ParkingSessionsIndex from "@/modules/Parkom/Submodules/ParkingSessions/Pages/Index.vue";
import Index from "@/modules/Parkom/Pages/Index.vue";
import BusControllersIndex from "@/modules/Parkom/Submodules/BusControllers/Pages/Index.vue";
import ICDManagementIndex from "@/modules/Parkom/Submodules/ICDManagement/Pages/Index.vue";
import StatisticsIndex from "@/modules/Parkom/Submodules/Statistics/Pages/Index.vue";
import NotificationIndex from "@/modules/Parkom/Submodules/NotificationManager/Pages/Index.vue";
import { Permissions } from "@/core/Services/Enums";
import IndexIntegration from "@/modules/Integrations/Pages/Index.vue";
import HealthIndex from "@/modules/Parkom/Submodules/Health/Pages/Index.vue";

export function createParkomIndexRoute(): RouteRecordRaw {
  return {
    name: "parkom",
    path: "/",
    component: Index,
    redirect: {
      name: "parkomDashboard",
    },
    meta: {
      id: "parkomIndex",
      label: "Sidebar.Parkom",
      icon: ["fas", "square-parking"],
      group: "main",
      showInNavigation: true,
      authorize: [Permissions.ViewAssignment],
    },
    children: [
      {
        name: "parkomDashboard",
        path: "/parkom/dashboard",
        component: Dashboard,
        meta: {
          id: "parkomDashboard",
          label: "Sidebar.Dashboard",
          icon: ["fas", "table-columns"],
          showInNavigation: true,
          authorize: [Permissions.ViewAssignment],
        },
      },
      {
        name: "parkomParkingSpaceIndex",
        path: "/parkom/parking-spaces",
        component: ParkingSpacesIndex,
        meta: {
          id: "parkomParkingSpaceIndex",
          label: "Sidebar.ParkingSpaces",
          icon: ["fas", "parking"],
          showInNavigation: true,
          dontDisplayOnMainNavigation: true,
          authorize: [Permissions.ViewAssignment],
        },
      },
      {
        name: "integrations",
        path: "/integrations",
        component: IndexIntegration,
        meta: {
          id: "integrationsIndex",
          label: "Sidebar.Integrations",
          icon: ["fas", "plug"],
          showInNavigation: true,
          group: "main",
          authorize: [Permissions.ViewIntegration],
        },
      },
      {
        name: "parkomParkingSpotIndex",
        path: "/parkom/parking-spots",
        component: ParkingSpotsIndex,
        meta: {
          id: "parkomParkingSpotIndex",
          label: "Sidebar.ParkingSpots",
          icon: ["fas", "location-dot"],
          showInNavigation: true,
          dontDisplayOnMainNavigation: true,
          authorize: [Permissions.ViewAssignment],
        },
      },
      {
        name: "parkomSensorsIndex",
        path: "/parkom/sensors",
        component: SensorsIndex,
        meta: {
          id: "parkomSensorsIndex",
          label: "Sidebar.Sensors",
          icon: ["fac", "parkom-sensor"],
          showInNavigation: true,
          dontDisplayOnMainNavigation: true,
          authorize: [Permissions.ViewAssignment],
        },
      },
      {
        name: "parkomDisplaysIndex",
        path: "/parkom/displays",
        component: DisplaysIndex,
        meta: {
          id: "parkomDisplaysIndex",
          label: "Sidebar.DigitalParkingSigns",
          icon: ["fac", "parkom-display"],
          showInNavigation: true,
          dontDisplayOnMainNavigation: true,
          authorize: [Permissions.ViewAssignment],
        },
      },
      {
        name: "parkomParkingSessionsIndex",
        path: "/parkom/parking-sessions",
        component: ParkingSessionsIndex,
        meta: {
          id: "parkomParkingSessionsIndex",
          label: "Sidebar.ParkingSessions",
          icon: ["fas", "clock"],
          showInNavigation: true,
          dontDisplayOnMainNavigation: true,
          authorize: [Permissions.ViewAssignment],
        },
      },
      {
        name: "parkomBusControllersIndex",
        path: "/parkom/bus-controllers",
        component: BusControllersIndex,
        meta: {
          id: "parkomBusControllersIndex",
          label: "Sidebar.BusControllers",
          icon: ["fas", "satellite-dish"],
          showInNavigation: true,
          dontDisplayOnMainNavigation: true,
          authorize: [Permissions.ViewAssignment],
        },
      },
      {
        name: "parkomHealthIndex",
        path: "/parkom/health",
        component: HealthIndex,
        meta: {
          id: "parkomHealthIndex",
          label: "Sidebar.SensorHealth",
          icon: ["fac", "parkom-sensor"],
          showInNavigation: true,
          dontDisplayOnMainNavigation: true,
          authorize: [Permissions.SensorHealthView],
        },
      },
      {
        name: "parkomICDManagementIndex",
        path: "/parkom/icd-management",
        component: ICDManagementIndex,
        meta: {
          id: "parkomICDManagementIndex",
          label: "Sidebar.ICDManagement",
          icon: ["fas", "satellite-dish"],
          showInNavigation: true,
          dontDisplayOnMainNavigation: true,
          authorize: [Permissions.ICDManagementView],
        },
      },
      {
        name: "parkomStatisticsIndex",
        path: "/parkom/statistics",
        component: StatisticsIndex,
        meta: {
          id: "parkomStatisticsIndex",
          label: "Sidebar.Statistics",
          icon: ["fas", "chart-simple"],
          showInNavigation: true,
          dontDisplayOnMainNavigation: true,
          authorize: [Permissions.StatisticsView],
        },
      },
      {
        name: "parkomNotificationIndex",
        path: "/parkom/notifications",
        component: NotificationIndex,
        meta: {
          id: "parkomNotificationIndex",
          label: "Sidebar.Notifications",
          icon: ["fas", "envelope"],
          showInNavigation: true,
          dontDisplayOnMainNavigation: true,
          authorize: [Permissions.ViewNotificationEmails],
        },
      },
    ],
  };
}
